import { render, staticRenderFns } from "./PlaylistSongModal.vue?vue&type=template&id=455b78c1&scoped=true"
import script from "./PlaylistSongModal.vue?vue&type=script&lang=js"
export * from "./PlaylistSongModal.vue?vue&type=script&lang=js"
import style0 from "./PlaylistSongModal.vue?vue&type=style&index=0&id=455b78c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b78c1",
  null
  
)

export default component.exports